import { Category } from './category';
import { ProductChild } from './product-child';

export class Product {
    id = 0;
    category_id = 0;
    external_code = '';
    title = '';
    caption = '';
    caption_short = '';
    photos = [];
    ribbon = '';
    ribbon_type = '';
    status = 0;
    meta = '';
    extra = '';
    barcode = '';
    stock = 0;
    sales = 0;
    video = '';
    is_feature = 0;
    photo_feature = '';
    views = '';

    category = new Category();
    childs = new Array<ProductChild>();
}
